var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 17.5815C13.6899 17.5815 17.5747 13.7051 17.5747 9.00684C17.5747 4.31689 13.6899 0.432129 8.9917 0.432129C4.30176 0.432129 0.425293 4.31689 0.425293 9.00684C0.425293 13.7051 4.31006 17.5815 9 17.5815ZM8.07861 13.1074C7.76318 13.1074 7.50586 12.9663 7.27344 12.6675L5.23975 10.1938C5.09033 10.0112 5.01562 9.81201 5.01562 9.60449C5.01562 9.18115 5.34766 8.83252 5.7793 8.83252C6.03662 8.83252 6.23584 8.93213 6.44336 9.19775L8.04541 11.2314L11.4819 5.73633C11.6562 5.4458 11.8887 5.30469 12.1543 5.30469C12.5693 5.30469 12.9429 5.59521 12.9429 6.02686C12.9429 6.21777 12.8433 6.42529 12.7271 6.60791L8.84229 12.6675C8.65137 12.9497 8.38574 13.1074 8.07861 13.1074Z","fill":"white"}));
}

Checkmark.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
